import { useResumeGetCertsAndSkills } from "@crowdcoursing/api/openapi";
import { DateTime } from "luxon";
import { useState } from "react";

import { type DateRangeValue } from "~ui/atoms/Form/DateRange/PopoverDateRangePicker";
import { SkillCertificationData } from "~ui/templates/AdminTemplate/DashboardStats/SkillCertificationData";

const START_DATE_STORAGE_KEY = "skillsCertificationsTab.startDate";

const getInitialTimeRange = (): DateRangeValue => {
  try {
    const stored = localStorage.getItem(START_DATE_STORAGE_KEY);
    if (stored) {
      const startDate = DateTime.fromISO(stored);
      if (startDate?.isValid) {
        return { endDate: DateTime.now(), startDate };
      }
    }
  } catch {
    // Fall through to default
  }
  return {
    endDate: DateTime.now(),
    startDate: DateTime.now().minus({ days: 30 }),
  };
};

const useSkillCertificationDataProps = () => {
  const { data, status } = useResumeGetCertsAndSkills({});
  const [timeRange, setTimeRange] = useState<DateRangeValue>(getInitialTimeRange);

  const handleTimeRangeChange = (newTimeRange: DateRangeValue) => {
    setTimeRange(newTimeRange);
    if (newTimeRange.startDate) {
      localStorage.setItem(START_DATE_STORAGE_KEY, newTimeRange.startDate.toISO() ?? "");
    }
  };

  return {
    certifications: data?.certifications ?? null,
    onTimeRangeChange: handleTimeRangeChange,
    skills: data?.skills ?? null,
    status,
    timeRange,
  };
};

export const SkillsCertificationsTab = () => {
  const props = useSkillCertificationDataProps();
  return <SkillCertificationData {...props} />;
};
